import React from "react";
import bgImage from "../../../assets/overview_img/integration/maroon-bg.jpg";

const IntegrationContact = () => {
  return (
    <section className="w-full overflow-hidden">
      
      {/* BACKGROUND */}
      <div
        className="w-full min-h-screen bg-cover bg-center bg-no-repeat flex items-center"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        
        {/* OVERLAY */}
        <div className="w-full min-h-screen bg-gradient-to-r from-[#2a0000]/90 via-[#3b0000]/75 to-[#d6491d]/45">
  
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-10">
    
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center min-h-screen">
      
      {/* LEFT SIDE */}
      <div className="text-white lg:pr-12 lg:-mt-[400px]  lg:-ml-[50px]">
        
        {/* TOP HEADING */}
        <h2 className="font-serif text-[42px] sm:text-[58px] lg:text-[44px] leading-[1] lg:leading-[60px] font-extralight tracking-[-1px]">
          Easy integration,
        </h2>

        {/* BIG TITLE */}
        <h1 className="text-[64px] sm:text-[90px] lg:text-[72px] font-serif leading-[1.0] font-black tracking-[-4px] text-white">
          real results
        </h1>

        {/* CONTENT */}
        <div className="mt-12 max-w-[620px]">
          
          <p className="text-[24px] lg:text-[15px] leading-[1.0] lg:-mt-4 font-medium mb-4 text-white">
            Ready to deliver a top-tier benefit without the technical lift?
          </p>

          <p className="text-[18px] sm:text-[20px] lg:text-[15px] leading-[1.8] lg:leading-[1.7] text-white/95 max-w-[600px]">
            Connect with our team to discover how DailyPay integrates <br className="hidden sm:block" />
            seamlessly with your current technology stack and elevates your HR <br className="hidden sm:block" />
            services without creating extra work.
          </p>
        </div>
      </div>
              {/* RIGHT FORM */}
              <div className="w-full flex justify-center lg:justify-end">
                
                <div className="w-full max-w-[560px] bg-white rounded-[4px] shadow-2xl p-5 sm:p-7 lg:p-8 lg:mt-[40px]">
                  
                  {/* NAME ROW */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                    
                    <div>
                      <label className="block text-[14px] font-semibold mb-2">
                        First Name<span className="text-red-500">*</span>
                      </label>

                      <input
                        type="text"
                        className="w-full h-[42px] border border-gray-300 px-3 text-[15px] outline-none focus:border-[#7b1400]"
                      />
                    </div>

                    <div>
                      <label className="block text-[14px] font-semibold mb-2">
                        Last Name<span className="text-red-500">*</span>
                      </label>

                      <input
                        type="text"
                        className="w-full h-[42px] border border-gray-300 px-3 text-[15px] outline-none focus:border-[#7b1400]"
                      />
                    </div>
                  </div>

                  {/* DEPARTMENT */}
              <div className="mb-4">
  <label className="block text-[14px] font-semibold mb-2">
    Department<span className="text-red-500">*</span>
  </label>

  <select
    defaultValue=""
    className="
      w-full
      h-[42px]
      border
      border-red-400
      bg-white
      px-3
      text-[16px]
      outline-none
    "
  >
    <option value="" disabled>
      Select...
    </option>

    <option>Benefits</option>
    <option>Communications/PR</option>
    <option>Diversity Equity and Inclusion</option>
    <option>Finance</option>
    <option>Human Resources</option>
    <option>Information & Technology</option>
    <option>Learning & Development</option>
    <option>Legal</option>
    <option>Marketing</option>
    <option>Operations & Revenue</option>
    <option>Payroll</option>
    <option>Product</option>
    <option>Sales & Business Development</option>
    <option>Strategy, Executive Office</option>
    <option>Talent</option>
    <option>Total Rewards</option>
  </select>

  <p className="text-red-500 text-[14px] mt-1">
    This field is required.
  </p>
</div>
                  {/* EMAIL */}
                  <div className="mb-4">
                    <label className="block text-[14px] font-semibold mb-2">
                      Work Email<span className="text-red-500">*</span>
                    </label>

                    <input
                      type="email"
                      className="w-full h-[42px] border border-red-300 px-3 text-[15px] outline-none focus:border-[#7b1400]"
                    />
                  </div>

                  {/* PHONE */}
                  <div className="mb-4">
                    <label className="block text-[14px] font-semibold mb-2">
                      Phone Number<span className="text-red-500">*</span>
                    </label>

                    <input
                      type="text"
                      className="w-full h-[42px] border border-gray-300 px-3 text-[15px] outline-none focus:border-[#7b1400]"
                    />
                  </div>

                  {/* COMPANY */}
                  <div className="mb-4">
                    <label className="block text-[14px] font-semibold mb-2">
                      Company Name<span className="text-red-500">*</span>
                    </label>

                    <input
                      type="text"
                      className="w-full h-[42px] border border-gray-300 px-3 text-[15px] outline-none focus:border-[#7b1400]"
                    />
                  </div>

                  {/* EMPLOYEES */}
                  <div className="mb-4">
                    <label className="block text-[14px] font-semibold mb-2">
                      Number of Employees
                      <span className="text-red-500">*</span>
                    </label>

                    <input
                      type="text"
                      className="w-full h-[42px] border border-gray-300 px-3 text-[15px] outline-none focus:border-[#7b1400]"
                    />
                  </div>

                  {/* MESSAGE */}
                  <div className="mb-6">
                    <label className="block text-[14px] font-semibold mb-2">
                      How can we help?
                    </label>

                    <textarea
                      rows="4"
                      className="w-full lg:h-[80px] border border-gray-300 p-3 text-[15px] outline-none resize-none focus:border-[#7b1400]"
                    ></textarea>
                  </div>

                  {/* BUTTON */}
                  <button className="bg-[#2b0902] hover:bg-[#451108] transition text-white px-7 py-3 text-[16px] font-semibold">
                    Submit
                  </button>

                  {/* FOOTER */}
                  <p className="text-[11px] text-gray-500 italic mt-6">
                    This site is protected by reCAPTCHA.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntegrationContact;